document.addEventListener('DOMContentLoaded', initFAQ);

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initFAQ);
}

function setQuestionState(question, isOpen) {
  const answer = question.querySelector('.faq-answer');
  const plus = question.querySelector('.plus');
  const minus = question.querySelector('.minus');

  if (!answer) return;

  question.classList.toggle('active', isOpen);
  answer.classList.toggle('active', isOpen);

  if (plus) {
    plus.style.display = isOpen ? 'none' : 'block';
  }

  if (minus) {
    minus.style.display = isOpen ? 'block' : 'none';
  }
}

function initFAQ() {
  const faqQuestions = document.querySelectorAll('.faq-question');

  faqQuestions.forEach((question, index) => {
    const isOpen = index === 0;
    setQuestionState(question, isOpen);

    if (question.dataset.bound === 'true') return;
    question.dataset.bound = 'true';

    question.addEventListener('click', function () {
      const isOpen = !this.classList.contains('active');

      faqQuestions.forEach((otherQuestion) => {
        setQuestionState(otherQuestion, otherQuestion === this && isOpen);
      });
    });
  });

  // Allow viewAllButton (.faqCta) to navigate to its href URL normally
}
